export default "__VITE_ASSET__8e24fc78__"